import { create } from 'zustand';

interface SharedFilesState {
  errorExceelStorageMessage: string;
  setErrorExceelStorageMessage: (message: string) => void;
}

export const useSharedFilesStore = create<SharedFilesState>((set) => ({
  errorExceelStorageMessage: "",
  setErrorExceelStorageMessage: (message) => set({ errorExceelStorageMessage: message }),
}));
